import { render, staticRenderFns } from "./PorcentajeCostos.vue?vue&type=template&id=1a69415e&"
import script from "./PorcentajeCostos.vue?vue&type=script&lang=js&"
export * from "./PorcentajeCostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports